/* 365 On Us landing page v2. Talks to the giveaway-enter edge function.
 * Requests go out as text/plain so the browser sends no CORS preflight.
 * Tracking uses window.apnTrack if present; no email, phone or name is ever sent to tracking.
 * ?gw_preview=dash shows the dashboard with sample numbers and writes nothing. */
(function () {
  'use strict';
  var GIVEAWAY_ID = '365-on-us-2026';
  var root = document.getElementById('gw365');
  if (!root) return;
  var qs = new URLSearchParams(location.search);
  var endpoint = root.getAttribute('data-endpoint') || '';
  var opens = new Date(root.getAttribute('data-opens')).getTime();
  var closes = new Date(root.getAttribute('data-closes')).getTime();
  var SITE = (root.getAttribute('data-site') || location.origin).replace(/\/$/, '');
  var SKOOL = root.getAttribute('data-skool');
  var IG = root.getAttribute('data-ig');
  var PREVIEW = qs.get('gw_preview') === 'dash';

  function $(id) { return document.getElementById(id); }
  function all(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function track(name, props) {
    try {
      if (!window.apnTrack) return;
      var p = props || {};
      window.apnTrack(name, { giveaway_id: GIVEAWAY_ID, has_referral: p.has_referral, sms_consent: p.sms_consent,
        entry_count: p.entry_count, error_code: p.error_code, path: location.pathname });
    } catch (e) {}
  }
  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function load(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  // The store header can sit over the page. Measure it and push the hero down when it is fixed.
  function fitHeader() {
    var h = document.querySelector('header');
    var pad = 0;
    if (h && window.getComputedStyle(h).position === 'fixed') pad = h.getBoundingClientRect().height;
    root.style.setProperty('--hd', pad + 'px');
  }
  fitHeader(); window.addEventListener('resize', fitHeader); window.addEventListener('load', fitHeader);

  // Countdown to the close (or to the open, before Nov 1).
  function tick() {
    var now = Date.now(), target = closes, label = 'Entries close in';
    if (now < opens) { target = opens; label = 'Entries open in'; }
    if (now >= closes) { $('gw-count-label').textContent = 'Entries are closed'; ['d', 'h', 'm', 's'].forEach(function (k) { $('gw-' + k).textContent = '00'; }); return; }
    $('gw-count-label').textContent = label;
    var s = Math.floor((target - now) / 1000);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    $('gw-d').textContent = pad(Math.floor(s / 86400));
    $('gw-h').textContent = pad(Math.floor(s % 86400 / 3600));
    $('gw-m').textContent = pad(Math.floor(s % 3600 / 60));
    $('gw-s').textContent = pad(s % 60);
  }
  tick(); setInterval(tick, 1000);

  // Entrance animation: visible by default, enabled only when the browser can observe.
  if ('IntersectionObserver' in window && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    root.classList.add('gw-js');
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    all('.gw-rv').forEach(function (n) { io.observe(n); });
    setTimeout(function () { all('.gw-rv').forEach(function (n) { n.classList.add('is-in'); }); }, 4000);
  }

  // Every [data-gw-top] goes to the card and focuses the first field.
  var card = $('gw-entry');
  function toTop(ev) {
    if (ev) ev.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = card.getBoundingClientRect().top + window.pageYOffset - (parseFloat(getComputedStyle(root).getPropertyValue('--hd')) || 0) - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    setTimeout(function () { var f = $('gw-first'); if (f && !f.closest('[hidden]')) f.focus({ preventScroll: true }); }, 450);
  }
  all('[data-gw-top]').forEach(function (a) { a.addEventListener('click', toTop); });

  var bar = $('gw-bar'), end = $('gw-end');
  if (bar && 'IntersectionObserver' in window) {
    var cardIn = true, endIn = false;
    var sync = function () { bar.classList.toggle('is-on', !cardIn && !endIn); };
    new IntersectionObserver(function (e) { cardIn = e[0].isIntersecting; sync(); }).observe(card);
    new IntersectionObserver(function (e) { endIn = e[0].isIntersecting; sync(); }).observe(end);
  }

  function show(state) { all('[data-gw-state]', card).forEach(function (s) { s.hidden = s.getAttribute('data-gw-state') !== state; }); }
  function err(m) { var e = $('gw-error'); e.textContent = m; e.hidden = !m; }
  function say(m, bad) { var e = $('gw-claim-msg'); e.textContent = m || ''; e.className = 'gw-msg' + (bad ? ' is-err' : ''); }

  // Referral capture.
  var ref = (qs.get('ref') || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 16);
  if (ref) store('gw365_ref', ref); else ref = load('gw365_ref') || '';
  if (ref) { $('gw-ref').value = ref; $('gw-ref-code').textContent = ref; $('gw-ref-note').hidden = false; }

  // Network: text/plain body, 20 second timeout, one retry on a dropped connection.
  function post(body, attempt) {
    attempt = attempt || 1;
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 20000);
    return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined })
      .then(function (r) { clearTimeout(timer); return r.json().catch(function () { return { ok: false, error: 'bad_response' }; }); })
      .catch(function () {
        clearTimeout(timer);
        if (attempt < 2) return new Promise(function (res) { setTimeout(res, 800); }).then(function () { return post(body, attempt + 1); });
        return { ok: false, error: 'network' };
      });
  }

  var MESSAGES = {
    invalid_email: 'That email does not look right. Check it and try again.',
    invalid_name: 'Enter your first name.',
    invalid_phone: 'That mobile number does not look right. Fix it or leave it blank.',
    rate_limited: 'Too many tries. Wait a minute and try again.',
    not_open: 'Entries open Sunday, Nov 1 at 12:00 AM Central. Come back then.',
    closed: 'Entries closed on Nov 30. Thank you for coming.',
    note_required: 'Add the link or handle first.',
    sms_locked: 'Text updates open soon.',
    network: 'We could not reach the server. Check your connection and try again.'
  };

  // Dashboard
  var token = null;
  function shareText(url) { return 'I entered to win a year of Ascend: 12 tubs of Replenish+ and the app. Free to enter. If you win through my link, I win too. ' + url; }
  function renderDash(s) {
    $('gw-hi').textContent = (s.first_name ? s.first_name + ', you are in' : 'Your entries');
    $('gw-total').textContent = s.entries;
    $('gw-friends').textContent = Math.min(s.friends, 10) + ' of 10 friends joined';
    $('gw-bar-fill').style.width = Math.min(100, s.entries / 3) + '%';
    $('gw-left').textContent = Math.max(0, 300 - s.entries);
    var url = SITE + '/win?ref=' + encodeURIComponent(s.referral_code);
    $('gw-link').value = url;
    $('sh-sms').href = 'sms:?&body=' + encodeURIComponent(shareText(url));
    $('sh-mail').href = 'mailto:?subject=' + encodeURIComponent('Win a year of Ascend with me') + '&body=' + encodeURIComponent(shareText(url));
    $('sh-x').href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(shareText(url));
    $('lnk-ig').href = IG; $('lnk-skool').href = SKOOL;
    function mark(id, done, btnText) {
      var t = $(id); t.classList.toggle('is-done', !!done);
      all('button[data-claim]', t).forEach(function (b) { b.disabled = !!done; if (btnText) b.textContent = done ? btnText : 'Claim'; });
      all('input', t).forEach(function (i) { i.disabled = !!done; });
    }
    mark('t-daily', s.done_today.daily, 'Claimed');
    mark('t-tag', s.done_today.tag, 'Done today');
    mark('t-ig', s.done_once.ig, 'Done');
    mark('t-skool', s.done_once.skool, 'Done');
    show('dash');
  }
  function refresh() {
    return post({ action: 'status', token: token }).then(function (s) {
      if (!s.ok) { if (s.error === 'invalid_token') { store('gw365_token', null); token = null; show('form'); } return s; }
      if (!s.confirmed) { show('thanks'); return s; }
      renderDash(s); return s;
    });
  }

  if (PREVIEW) {
    token = 'preview';
    renderDash({ first_name: 'Sam', entries: 46, friends: 3, referral_code: 'DEMO1234', done_today: { daily: true, tag: false }, done_once: { ig: false, skool: true } });
    say('Preview only. Nothing here is saved.');
  }

  all('[data-claim]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (PREVIEW) return say('Preview only. Nothing here is saved.');
      var kind = b.getAttribute('data-claim'), from = b.getAttribute('data-from'), note = from ? $(from).value.trim() : null;
      if (from && !note) return say(MESSAGES.note_required, true);
      b.disabled = true; say('');
      post({ action: 'claim', token: token, kind: kind, note: note }).then(function (r) {
        b.disabled = false;
        if (!r.ok) return say(MESSAGES[r.error] || 'That did not go through. Try again.', true);
        say(r.credited > 0 ? '+' + r.credited + ' entries added.' : 'Already counted. Come back tomorrow for the daily ones.');
        track('giveaway_claim', { entry_count: r.entries });
        refresh();
      });
    });
  });

  all('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var el = $(b.getAttribute('data-copy')); el.select(); el.setSelectionRange(0, 999);
      var done = function () { var t = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = t; }, 1600); };
      try { navigator.clipboard.writeText(el.value).then(done, function () { document.execCommand('copy'); done(); }); } catch (e) { try { document.execCommand('copy'); done(); } catch (x) {} }
    });
  });

  // Start: token from the email link, else a saved token, else the entry form.
  var urlToken = (qs.get('confirm') || '').trim().toLowerCase();
  if (!PREVIEW) {
    if (urlToken) {
      post({ action: 'confirm', token: urlToken }).then(function (r) {
        if (!r.ok) { show('form'); err(r.error === 'network' ? MESSAGES.network : 'That link is not valid or has expired. Enter again below.'); return; }
        token = urlToken; store('gw365_token', token);
        if (r.status === 'confirmed') { track('giveaway_confirmed', { entry_count: r.entries }); if (r.referral_credited) track('giveaway_referral_confirmed', { has_referral: true }); }
        refresh().then(function () { toTop(); });
      });
    } else {
      token = load('gw365_token');
      if (token) refresh(); else track('giveaway_viewed', { has_referral: !!ref });
    }
  }

  // Weekly flash product.
  if (endpoint) {
    post({ action: 'flash' }).then(function (r) {
      var f = r && r.ok ? r.flash : null; if (!f) return;
      $('fl-k').textContent = 'This week';
      $('fl-name').textContent = f.label;
      var d = new Date(f.ends_at);
      $('fl-end').textContent = 'Double entries until ' + d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric', timeZone: 'America/Chicago' }) + '.';
      var a = $('fl-go'); a.href = '/products/' + f.handle; a.style.display = 'inline-flex';
    });
  }

  // Entry form
  var form = $('gw365-form');
  form.addEventListener('submit', function (ev) {
    ev.preventDefault(); err('');
    var f = form.elements, email = f.email.value.trim(), first = f.first_name.value.trim(), phone = f.phone.value.trim(), sms = f.sms_consent.checked;
    if (!first) return err(MESSAGES.invalid_name);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return err(MESSAGES.invalid_email);
    if (sms && phone.replace(/\D/g, '').length < 10) return err('Add a mobile number to get texts, or untick the box.');
    var btn = $('gw-submit'), label = btn.textContent; btn.disabled = true; btn.textContent = 'Entering...';
    post({ action: 'enter', email: email, first_name: first, phone: phone || null, sms_consent: sms && !!phone, ref: f.ref.value || null, hp: f.company.value || '', source_path: location.pathname })
      .then(function (r) {
        btn.disabled = false; btn.textContent = label;
        if (!r.ok) { track('giveaway_submitted', { has_referral: !!ref, error_code: r.error || 'failed' }); return err(MESSAGES[r.error] || 'Something went wrong on our side. Try again in a minute.'); }
        show('thanks');
        if (r.status === 'created') track('giveaway_submitted', { has_referral: !!ref, sms_consent: sms && !!phone, entry_count: r.entries });
      });
  });
})();